import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
// import { GridToolbar } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';

import { GRID_DEFAULT_LOCALE_TEXT } from './textLocation';
import DataCard from '../DataCard';

export default function DataTable({columnsTable, fieldId, pageSize, rowsPerPageOptions, data, isLoading, handleOpen}) {

  const deskTop = useMediaQuery('(min-width:900px)');

  return (

    <React.Fragment>

        {deskTop? (

          <Box sx={{ display: {xs: 'none', sm: 'flex'}, 
                 height: '68vh', 
                 width: '95%',
                 justifyContent: 'center',
                 alignSelf: 'center', 
                 bgcolor: 'background.paper',
          }}>

            <DataGrid
                sx={{ display: {xs: 'none', sm: 'flex'} }}
                disableSelectionOnClick
                disableColumnMenu
                getRowId={(row) => row[fieldId]}
                rows={data}
                columns={columnsTable}
                pageSize={pageSize}
                rowsPerPageOptions={[rowsPerPageOptions]}
                loading={isLoading}
                // components={{
                //     Toolbar: GridToolbar,
                // }}
                
                localeText={GRID_DEFAULT_LOCALE_TEXT}
            />

          </Box>

        ) :
        (

          <DataCard
            isLoading={isLoading}
            data={data}
            fieldId={fieldId}
            handleOpen={handleOpen}
          />

        )}

    </React.Fragment>

  );
};
